import {Component, OnInit} from '@angular/core';
import {FooterComponent} from '../footer/footer.component';
import {ToolbarComponent} from '../toolbar/toolbar.component';

@Component({
    selector: 'frog-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    imports: [ToolbarComponent, FooterComponent],
})
export class TermsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
